import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import { colors } from '../../../const/color';
import IconNonFilledStyled from '../icon-non-fill.styled';

const IconAdditionalInfo: FC<IconProps> = ({ $size, ...rest }) => {
  return (
    <IconNonFilledStyled {...{ $size, ...rest }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 32 32" fill="none">
        <circle cx="16" cy="16" r="16" fill="white" />
        <path
          d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
          stroke={colors[rest?.$color]}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15 15H16V22H17"
          stroke={colors[rest?.$color]}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.75 12C16.5784 12 17.25 11.3284 17.25 10.5C17.25 9.67157 16.5784 9 15.75 9C14.9216 9 14.25 9.67157 14.25 10.5C14.25 11.3284 14.9216 12 15.75 12Z"
          fill={colors[rest?.$color]}
        />
      </svg>
    </IconNonFilledStyled>
  );
};

IconAdditionalInfo.defaultProps = iconDefaultProps;
IconAdditionalInfo.displayName = 'IconAdditionalInfo';

export default IconAdditionalInfo;
